import { render, staticRenderFns } from "./HotComment.vue?vue&type=template&id=22ee5b34&scoped=true&"
import script from "./HotComment.vue?vue&type=script&lang=js&"
export * from "./HotComment.vue?vue&type=script&lang=js&"
import style0 from "./HotComment.vue?vue&type=style&index=0&id=22ee5b34&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ee5b34",
  null
  
)

export default component.exports